import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const useSettings = () => {
  const [settings, setSettings] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      // Check if Supabase is initialized properly
      if (!supabase) {
        throw new Error('Connessione al database non disponibile');
      }

      const { data, error } = await supabase
        .from('settings')
        .select('*')
        .single();

      if (error) throw error;
      setSettings(data || {}); // Provide default empty object if data is null
    } catch (err: any) {
      console.error('Error fetching settings:', err);
      setError(err.message);
      // Set default settings to prevent UI breakage
      setSettings({});
    } finally {
      setLoading(false);
    }
  };

  return { settings, loading, error };
};